import { useEffect, useState } from "react";
import api from "../../lib/api";
import Input from "../../components/ui/Input";
import { formatPrice } from "../../lib/utils";
import ProUpgradeNotice from "../../components/business/ProUpgradeNotice";

export default function StaffPerformance() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [proRequired, setProRequired] = useState(false);
  const [from, setFrom] = useState(() => new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().slice(0, 10));
  const [to, setTo] = useState(() => new Date().toISOString().slice(0, 10));

  const load = () => {
    setLoading(true);
    api
      .get("/owner/staff-performance", { params: { from, to } })
      .then(({ data }) => setRows(data))
      .catch((err) => {
        setRows([]);
        setProRequired(err?.response?.status === 402);
      })
      .finally(() => setLoading(false));
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps -- load only on mount; "Apply" re-triggers explicitly
  useEffect(load, []);

  if (proRequired) {
    return (
      <div>
        <h1 className="mb-4 font-montserrat text-2xl font-bold text-slate-900">Staff performance</h1>
        <ProUpgradeNotice feature="Staff analytics" />
      </div>
    );
  }

  return (
    <div>
      <h1 className="mb-2 font-montserrat text-2xl font-bold text-slate-900">Staff performance</h1>
      <p className="mb-4 text-sm text-muted-foreground">Completed appointments, revenue, and commission earned per staff member.</p>

      <div className="mb-4 flex flex-wrap items-end gap-2">
        <div>
          <label className="mb-1 block text-xs text-muted-foreground">From</label>
          <Input type="date" value={from} onChange={(e) => setFrom(e.target.value)} className="w-auto" />
        </div>
        <div>
          <label className="mb-1 block text-xs text-muted-foreground">To</label>
          <Input type="date" value={to} onChange={(e) => setTo(e.target.value)} className="w-auto" />
        </div>
        <button onClick={load} className="h-11 rounded-xl border border-border px-4 text-sm font-medium hover:bg-muted">
          Apply
        </button>
      </div>

      {loading ? (
        <p className="text-muted-foreground">Loading…</p>
      ) : rows.length === 0 ? (
        <p className="text-muted-foreground">No staff yet.</p>
      ) : (
        <div className="overflow-x-auto rounded-2xl border border-border">
          <table className="w-full text-sm">
            <thead className="bg-muted text-left text-xs uppercase tracking-wide text-muted-foreground">
              <tr>
                <th className="p-3">Staff</th>
                <th className="p-3">Completed</th>
                <th className="p-3">Revenue</th>
                <th className="p-3">Commission</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border">
              {rows
                .sort((a, b) => b.revenue - a.revenue)
                .map((r) => (
                  <tr key={r.staff_id}>
                    <td className="p-3 font-medium text-slate-900">{r.name}</td>
                    <td className="p-3">{r.completed_appointments}</td>
                    <td className="p-3">{formatPrice(r.revenue)}</td>
                    <td className="p-3">{formatPrice(r.commission_earned)}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
